<template>
    <b-card-body v-if="result">
        
        <table class="table table-md mb-3">
            <thead>
                <tr>
                    <th>Segment</th>
                    <th>Orders</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in result" :key="item.category">
                    <td>{{item.category}}</td>
                    <td>{{item.orders}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th>Total</th>
                    <th>{{ $sum(result, 'orders') }}</th>
                </tr>
            </tfoot>
        </table>

    </b-card-body>
</template>

<script>
import mixin from "../../mixins/area";

export default {
    data: () => ({
        result: null,
    }),
    components: {  },
    watch: {
        entity: {
            deep: true,
            handler() {
                this.getResult();
            }
        }
    },
    computed: {},
    methods: {
        getResult() {
            this.$http.post("/api/module/dashboard/segmentedorders", {
                dates: this.entity.dates,
                user: this.entity.user,
                franchise: this.entity.franchise
            }).then(x => {
                this.result = x.data;
            });
        },
    },
    created() {
        this.getResult();
    },
    mounted() {

    },
    mixins: [mixin]
};
</script>

<style lang="scss">


</style>